import * as THREE from 'three'
import React from 'react'
import { Html } from '@react-three/drei'
import { Walkspot } from '../../../assets'
import { HotspotInfoIcon, HotspotDroneIcon } from '../../../components'
import { HotspotOutdoorIcon } from '../../icons'
import { FormattedMessage, IntlProvider } from 'react-intl'
import { messages } from '../../../app'
const areas = require('./../../../assets/mock-data/areas.json')


const VRHotspot = React.memo(({ 
    square, circle, history, hotspot, onClickVideo, onClickInfo, onClickCollection, onClickLayer, locale
}) => {
    const [hovered, setHover] = React.useState(false)
    const [showDescrition, setShowDescription] = React.useState(false);
    const onOverHotspot = (() => hotspot.hover && setHover(false))
    const onOutHotspot = (() => hotspot.hover && setHover(false))
    const onClickHotspot = (() => {
        hotspot.to && history && history.push(hotspot.to, history.location.pathname)
    })
    const scale = hovered ? hotspot.hoverSize : (hotspot.size ?? [-50, 50])
    const position = hotspot.position ?? [0, 0, 0]
    const rotation = hotspot.rotation ?? [0, 0, 0]

    const mouseOver = () => {
        setShowDescription(true);
    }

    const mouseOut = () => {
        setShowDescription(false);
    }

    const getLabelArea = () => {
        if(hotspot.areaId !== undefined) {
            let area = areas.find(x => x.id === hotspot.areaId)
            if(area){ 
                return area.title
            }
            return;
        }
        return;
    }

    if(hovered){
        document.getElementsByTagName('body')[0].className = "pointer"
    }else{
        document.getElementsByTagName('body')[0].className = ""
    }

    if (hotspot.type === "visit") return (
        <mesh
            key={hotspot.name}
            className="canvas-hover"
            onPointerOver={(e) => { !hovered && setHover(true) }}
            onPointerOut={(e) => { hovered && setHover(false) }}
            onPointerDown={onClickHotspot}
            position={position}
            rotation={rotation}
            scale={scale}
        >
            {square && <planeBufferGeometry attach="geometry" args={[1, 1]} />}
            {circle && <circleGeometry attach="geometry" args={[0.5, 50]} />}
            <meshBasicMaterial map={new THREE.TextureLoader().load(Walkspot)} side={THREE.DoubleSide} blending={THREE.AdditiveBlending} opacity={hovered ? 1 : 0.7} transparent={true} needsUpdate={false} />
        </mesh>
    )

    let label = getLabelArea()
    return (
        <mesh
            key={hotspot.name}
            onPointerOver={onOverHotspot}
            onPointerOut={onOutHotspot}
            className={`canvas-hover`}
            position={position}
            rotation={rotation}
            scale={scale}
        >
            <Html scaleFactor={hotspot.scale || 1000} zIndexRange={!hovered ? [3,0] : [3,0]} center={true}>
                <IntlProvider locale={locale} messages={messages[locale]}>
                    {(hotspot.type === "video") && (
                        <div className={`info-icon video`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                            onClickVideo(hovered)
                            hotspot.hover && setHover(!hovered)
                            
                        }}>
                            <HotspotInfoIcon />
                        </div>
                    )}

                    {(hotspot.type === "go-to") && (
                        <div className={`info-icon video`}
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                            onClickHotspot()
                            hotspot.hover && setHover(!hovered)
                        }}>
                            <HotspotInfoIcon />
                        </div>
                    )}

                    {(hotspot.type === "info") && (
                        <div className={`info-icon video`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                            onClickInfo(hovered, hotspot.info)
                            hotspot.hover && setHover(!hovered)
                        }}>
                            <HotspotInfoIcon />
                        </div>
                    )}

                    {(hotspot.type === "popup-cork") && (
                        <div className={`info-icon video`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                            onClickInfo(hovered, hotspot.info)
                            hotspot.hover && setHover(!hovered)
                        }}>
                            <HotspotInfoIcon />
                        </div>
                    )}

                    {(hotspot.type === "popup-video") && (
                        <div className={`info-icon video`}
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                            onClickInfo(hovered, hotspot.info)
                            hotspot.hover && setHover(!hovered)
                        }}>
                            <HotspotInfoIcon />
                        </div>
                    )}

                    {(hotspot.type === "outdoor") && (
                        <div 
                            className={`info-icon ${hovered ? 'hovered': ''}`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                                onClickHotspot()
                                hotspot.hover && setHover(!hovered)
                            }}
                            onPointerOver={(e) => { !hovered && setHover(true) }}
                            onPointerOut={(e) => { hovered && setHover(false) }}
                        >
                            <HotspotOutdoorIcon  arrowFill={"#fff"} fill={"#2D5A64"} opacity={1} />
                        </div>
                    )}

                    {(hotspot.type === "panorama-spot") && (
                        <div 
                            className={`info-icon ${hovered ? 'hovered': ''}`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                                onClickHotspot()
                                hotspot.hover && setHover(!hovered)
                            }}
                            onPointerOver={(e) => { !hovered && setHover(true) }}
                            onPointerOut={(e) => { hovered && setHover(false) }}
                        >
                            <HotspotOutdoorIcon />
                        </div>
                    )}


                    {(hotspot.type === "visit-area") && (
                        <div className={`info-icon`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                            onClickInfo(hovered, hotspot.areaId)
                            hotspot.hover && setHover(!hovered)
                        }}>
                            <HotspotInfoIcon />
                            <div className="hit" />
                            {label && <div className={`hotspot-description ${showDescrition ? 'hovered' : ''} `}><FormattedMessage id={label} /></div>}
                        </div>
                    )}

                    {(hotspot.type === "collection") && (
                        <div className={`info-icon`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                            onClickCollection(hovered, hotspot.collectionId)
                            hotspot.hover && setHover(!hovered)
                        }}>
                            <HotspotInfoIcon />
                        </div>
                    )}

                    {(hotspot.type === "layer") && (
                        <div className={`info-icon`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                            onClickLayer(hovered, hotspot.layerId)
                            hotspot.hover && setHover(!hovered)
                        }}>
                            <HotspotInfoIcon />
                        </div>
                    )}

                    {(hotspot.type === "popup") && (
                        <div className={`info-icon`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                            onClickInfo(hovered, hotspot.infoId)
                            hotspot.hover && setHover(!hovered)
                        }}>
                            <HotspotInfoIcon />
                        </div>
                    )}

                    {(hotspot.type === "info-message") && (
                        <div className={`info-icon`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                            onClickInfo(hovered, hotspot.infoId)
                            hotspot.hover && setHover(!hovered)
                        }}>
                            <HotspotInfoIcon />
                        </div>
                    )}

                    {(hotspot.type === "process-info") && (
                        <div className={`info-icon`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                            onClickInfo(hovered, hotspot.infoId)
                            hotspot.hover && setHover(!hovered)
                        }}>
                            <HotspotInfoIcon />
                        </div>
                    )}

                    {(hotspot.type === "showroom") && (
                        <div className={`info-icon`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                            history.push('/splash-split')
                        }}>
                            <HotspotInfoIcon />
                            <div className="hit" />
                            <div className={`hotspot-description ${showDescrition ? 'hovered' : ''} `}><FormattedMessage id={"menu.showroom"} /></div>
                        </div>
                    )}

                    {(hotspot.type === "drone") && (
                        <div 
                            className={`info-icon drone`} 
                            onMouseOver={() => mouseOver()}
                            onMouseOut={() => mouseOut()}
                            onClick={() => {
                                onClickHotspot()
                                hotspot.hover && setHover(!hovered)
                            }}
                        >
                            <HotspotDroneIcon />
                        </div>
                    )}
                </IntlProvider>
            </Html>
        </mesh>
    )

})

export default VRHotspot